import React, {Component} from 'react'

class ItemsTableHead extends Component {
    render() {
        return (
            <thead className='thead-light'>
            <tr>
                <th/>
                <th>Template</th>
                <th>Trạng thái</th>
            </tr>
            </thead>
        )
    }
}

export default ItemsTableHead